// extracted by mini-css-extract-plugin
export default {"lightishBlue":"#557fff","clearWhite":"#fff","offWhite":"#dcdcdc","lightGreenTwo":"#dde6e2","darkGreenTwo":"#17593e"};